import React from 'react';

import { Container } from './styles';

import InputCurrencySp from '../../../../components/InputCurrencySp';

function InputCurrency(props) {
  const { required, ...rest } = props;

  return (
    <Container required={required}>
      <InputCurrencySp className={required ? 'required' : ''} {...rest} />
    </Container>
  );
}

export default InputCurrency;
